<template>

  <ContentsProductHighPerformancePageTitle title="PPSU (Polyphenylsulfone)" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/ppsu01.jpg"
            :contents="[
              `PPSU is the highest performance among sulfone polymers although a little lower heat (Tg 220c). It has very high impact strength over PSU, PES, and PEI. PPSU is suitable for parts that are exposed to high temperatures and corrosive agent because of exceptional chemical resistance and hydrolytic stability.`,
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/ppsu02.jpg"
            credit="Photo credit : https://www.hegen.com"
            :contents="[
              `Medical devices, baby bottle, aerospace parts, hot water plumbing, connector`,
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'BASF',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo01.jpg',
              },
            },
            {
              name: 'Solvay',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo02.jpg',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>
  
</template>
<script setup lang="ts">
useHead({
  title: 'pssu - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>